import { Drawer } from "@mantine/core";
import { SystemEmailPreviewLoader } from "./SystemEmailPreviewLoader";

interface Props {
  emailTypeId: string | null;
  opened: boolean;
  onClose: () => void;
}

export function SystemEmailPreviewDrawer({
  emailTypeId,
  opened,
  onClose,
}: Props) {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="right"
      size="xl"
      title="Recipient preview"
    >
      <SystemEmailPreviewLoader emailTypeId={opened ? emailTypeId : null} />
    </Drawer>
  );
}
